import React from "react";
import { BeatLoader } from "react-spinners";
import logoh from "../../assets/logoh.png";

export default class SpinnerModal extends React.Component {
  static defaultProps = {
    verImagen: false,
    show: false,
  };

  render() {
    const { show, verImagen } = this.props;

    return (
      <div className="newspiner">
        <main className="mainspinners">
          {verImagen ? <img className="lagospiner" src={logoh} alt="" /> : null}

          <div>
            <BeatLoader
              color="#ffffff"
              loading={show}
              css="display: block; margin:auto; fontWeight:bold;"
              margin={9}
              size={25}
              speedMultiplier={0.8}
            />
          </div>
        </main>
      </div>
    );
  }
}
